<template>
 <div>
    <div class="detailsTitle" >
       <h4>货物明细</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="box">
             <el-form-item label="捆包号:" class="item1">
              <!-- <el-input type="textarea" :rows="3" v-model.trim="searchFrom.cargoBarcodes" style="width: 175px; vertical-align: top" size="mini"></el-input> -->
              <el-input placeholder="" type="textarea" v-model="searchFrom.cargoBarcodes" class="gjh"></el-input>
            </el-form-item>
            <el-form-item label="合同号:">
              <el-input size="mini" v-model.trim="searchFrom.contractNumber" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="合约号:">
              <el-input size="mini" v-model.trim="searchFrom.agreementNumber" placeholder=""></el-input>
            </el-form-item>
             <el-form-item label="喷码状态:">
              <el-select v-model="searchFrom.inkjetStatus" size="mini" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="未喷码" value="未喷码"></el-option>
                <el-option label="已喷码" value="已喷码"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="重量:">
              <el-input size="mini" v-model.trim="searchFrom.weight" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="货垛号:">
              <el-input size="mini" v-model.trim="searchFrom.palletNo" placeholder=""></el-input>
            </el-form-item>
             <el-form-item label="喷码人:">
              <el-input size="mini" v-model.trim="searchFrom.inkjetUser" placeholder=""></el-input>
            </el-form-item>
        </div>
        <div style="padding-bottom: 10px">
          <el-form-item>
            <el-button type="primary" @click="searchFn" size="mini" >查询</el-button>
            <el-button type="primary" @click="resetForm" size="mini">重置</el-button>
            <el-button type="primary"  @click="delFn">删除</el-button>
            <el-button type="primary"  @click="daoruFn">导入货物</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="inkjetStatus" label="喷码状态" ></el-table-column>
        <el-table-column property="agreementNumber" :formatter="emptyFn" width="120" label="合约号"></el-table-column>
        <el-table-column property="contractNumber" width="120" :formatter="emptyFn" label="合同号"></el-table-column>
        <el-table-column property="cargoBarcode" width="240"  label="捆包号"></el-table-column>
        <el-table-column property="numberCladding" width="120"  label="包层数"></el-table-column>
        <el-table-column prop="model" width="150" :formatter="emptyFn" label="钢种"></el-table-column>
        <el-table-column prop="thickness" width="150" :formatter="emptyFn" label="订单厚度(mm)"></el-table-column>
        <el-table-column prop="dealDuration" width="120" :formatter="emptyFn" label="订单宽度(mm)"></el-table-column>
        <el-table-column prop="length" width="150" :formatter="emptyFn" label="长度(mm)"></el-table-column>
        <el-table-column prop="numberOfSheet"  min-width="200" :formatter="emptyFn" label="张数"></el-table-column>
        <el-table-column prop="weight" width="150" :formatter="emptyFn" label="重量(吨)"></el-table-column>
        <el-table-column prop="palletNo" width="150" :formatter="emptyFn" label="货垛号"></el-table-column>
        <el-table-column prop="mark" width="150" :formatter="emptyFn" label="标记"></el-table-column>
        <el-table-column prop="inkjetUser" width="120" :formatter="emptyFn" label="喷码人"></el-table-column>
        <el-table-column prop="inkjetTime" width="170" :formatter="dateTimeFormat"  label="喷码时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <!-- 导入 -->
    <importC   v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getShipInkjetDetailList, delShipInkjetDetail, addShipInkjetDetail } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import importC from '@/components/import.vue'
export default {
  components: {
    importC
  },
  data () {
    let id = this.$route.query.id
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        taskId: id
      },
      total: 0,
      id: id,
      importDialog: false
    }
  },
  created () {
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 删除
    delFn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let isHQ = true
        this.ids = []
        selectData.some(item => {
          this.ids.push(item.id)
        })
        if (isHQ) {
          this.$confirm('是否执行删除操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            delShipInkjetDetail({ ids: this.ids, taskId: this.id }).then(res => {
              loading.close()
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {

          })
        }
      }
    },
    // 导入
    daoruFn () {
      this.importDialog = true
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      formData.set('params', JSON.stringify({ id: this.id }))
      addShipInkjetDetail(formData).then(res => {
        loading.close()
        this.importDialog = false
        this.importMsg = this.$message({
          showClose: true,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {
            loading.close()
          }
        })
        // that.getList(that.searchFrom)
        this.getList(this.searchFrom)
      }).catch(error => {
        this.importMsg = this.$message({
          showClose: true,
          message: error.message,
          duration: 3000,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcode = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.cargoBarcode = null
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      getShipInkjetDetailList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        taskId: this.id
      }
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
/deep/ .searchBox .el-form--inline .el-form-item {
  margin-bottom: 10px;
}
/deep/.searchBox {
  .el-input {
    width: 150px;
    display: inline-block;
  }
  .el-input__inner {
    width: 100%;
  }
}
/deep/.el-form{
  width: 100%;
}

.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 270px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
</style>
